// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"90262d30","298":"0ea0ece5","432":"96f4f515","441":"3d819cfb","453":"7f72ec0f","740":"b413e857","812":"b2d2bbc1"}[chunkId] + ".chunk.js";
};